__turbopack_context__.v({
  "card": "market-faq-page-module-scss-module__RTyUvW__card",
  "cardArrow": "market-faq-page-module-scss-module__RTyUvW__cardArrow",
  "cardFadeIn": "market-faq-page-module-scss-module__RTyUvW__cardFadeIn",
  "cardFooter": "market-faq-page-module-scss-module__RTyUvW__cardFooter",
  "cardIcon": "market-faq-page-module-scss-module__RTyUvW__cardIcon",
  "cardMeta": "market-faq-page-module-scss-module__RTyUvW__cardMeta",
  "cardName": "market-faq-page-module-scss-module__RTyUvW__cardName",
  "cardPrice": "market-faq-page-module-scss-module__RTyUvW__cardPrice",
  "cardRegion": "market-faq-page-module-scss-module__RTyUvW__cardRegion",
  "cardTop": "market-faq-page-module-scss-module__RTyUvW__cardTop",
  "container": "market-faq-page-module-scss-module__RTyUvW__container",
  "filterLabel": "market-faq-page-module-scss-module__RTyUvW__filterLabel",
  "filterPill": "market-faq-page-module-scss-module__RTyUvW__filterPill",
  "filterPillActive": "market-faq-page-module-scss-module__RTyUvW__filterPillActive",
  "filterRow": "market-faq-page-module-scss-module__RTyUvW__filterRow",
  "grid": "market-faq-page-module-scss-module__RTyUvW__grid",
  "hero": "market-faq-page-module-scss-module__RTyUvW__hero",
  "heroTitle": "market-faq-page-module-scss-module__RTyUvW__heroTitle",
  "searchIcon": "market-faq-page-module-scss-module__RTyUvW__searchIcon",
  "searchInput": "market-faq-page-module-scss-module__RTyUvW__searchInput",
  "searchWrap": "market-faq-page-module-scss-module__RTyUvW__searchWrap",
  "trendBadgeDown": "market-faq-page-module-scss-module__RTyUvW__trendBadgeDown",
  "trendBadgeUp": "market-faq-page-module-scss-module__RTyUvW__trendBadgeUp",
  "trendTooltip": "market-faq-page-module-scss-module__RTyUvW__trendTooltip",
  "trendingSlot": "market-faq-page-module-scss-module__RTyUvW__trendingSlot",
  "trendingTag": "market-faq-page-module-scss-module__RTyUvW__trendingTag",
});
